import { ThailandArticleKey } from '../../articles/thailand/thailand-articles-card-map';
import { ThailandDestinationKey } from './thailand-destinations-card-map';

export const relatedArticlesSlugsMap: Record<
  ThailandDestinationKey,
  (ThailandDestinationKey | ThailandArticleKey)[]
> = {
  bangkok: [
    'ko-kret',
    'bangkachao',
    'lumphini-park',
    'benchakitti-park',
    'wat-saket',
    'kanchanaburi',
    'bangkok-transportation',
    'bangkok-markets',
    'bangkok-malls',
    'khaosan-road',
    'floating-market',
    'train-night-market',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'chiang-mai': [
    'pai',
    'chiang-rai',
    'khlong-mae-kha',
    'doi-inthanon',
    'chiang-mai-markets',
    'chiang-mai-attractions',
    'chiang-mai-pai-chiang-rai-road-attractions',
    'thailand-myanmar-border-trip',
    'chiang-rai-to-golden-triangle',
    'chiang-rai-to-chiang-mai',
    'general-thailand',
    'thailand-tax-refund',
  ],
  phuket: [
    'krabi',
    'koh-phi-phi',
    'ko-lanta',
    'koh-lipe',
    'khao-lak',
    'khao-sok',
    'similan-islands',
    'ko-surin-nuea',
    'emerald-cave',
    'general-thailand',
    'thailand-tax-refund',
  ],
  krabi: [
    'phuket',
    'koh-phi-phi',
    'ko-lanta',
    'koh-lipe',
    'khao-lak',
    'khao-sok',
    'similan-islands',
    'ko-surin-nuea',
    'emerald-cave',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'koh-samui': [
    'koh-phangan',
    'koh-tao',
    'general-thailand',
    'thailand-tax-refund',
  ],
  pai: [
    'chiang-mai',
    'chiang-rai',
    'doi-inthanon',
    'khlong-mae-kha',
    'chiang-mai-markets',
    'chiang-mai-attractions',
    'chiang-mai-pai-chiang-rai-road-attractions',
    'thailand-myanmar-border-trip',
    'chiang-rai-to-golden-triangle',
    'chiang-rai-to-chiang-mai',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'koh-phangan': [
    'koh-samui',
    'koh-tao',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'chiang-rai': [
    'pai',
    'chiang-mai',
    'khlong-mae-kha',
    'doi-inthanon',
    'chiang-mai-markets',
    'chiang-mai-attractions',
    'chiang-mai-pai-chiang-rai-road-attractions',
    'thailand-myanmar-border-trip',
    'chiang-rai-to-golden-triangle',
    'chiang-rai-to-chiang-mai',
    'general-thailand',
    'thailand-tax-refund',
  ],
  kanchanaburi: [
    'hua-hin',
    'pattaya',
    'koh-larn',
    'bangkok',
    'bangkok-markets',
    'train-night-market',
    'floating-market',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'koh-phi-phi': [
    'phuket',
    'krabi',
    'ko-lanta',
    'koh-lipe',
    'khao-lak',
    'khao-sok',
    'similan-islands',
    'ko-surin-nuea',
    'emerald-cave',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'koh-tao': [
    'koh-samui',
    'koh-phangan',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'koh-lipe': [
    'phuket',
    'krabi',
    'ko-lanta',
    'koh-phi-phi',
    'khao-lak',
    'khao-sok',
    'similan-islands',
    'ko-surin-nuea',
    'emerald-cave',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'ko-lanta': [
    'phuket',
    'krabi',
    'koh-lipe',
    'koh-phi-phi',
    'khao-lak',
    'khao-sok',
    'similan-islands',
    'ko-surin-nuea',
    'emerald-cave',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'khao-sok': [
    'phuket',
    'krabi',
    'koh-lipe',
    'koh-phi-phi',
    'khao-lak',
    'ko-lanta',
    'similan-islands',
    'ko-surin-nuea',
    'emerald-cave',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'similan-islands': [
    'phuket',
    'krabi',
    'koh-lipe',
    'koh-phi-phi',
    'khao-lak',
    'khao-sok',
    'ko-lanta',
    'ko-surin-nuea',
    'emerald-cave',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'ko-surin-nuea': [
    'phuket',
    'krabi',
    'koh-lipe',
    'koh-phi-phi',
    'khao-lak',
    'khao-sok',
    'similan-islands',
    'ko-lanta',
    'emerald-cave',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'khao-lak': [
    'phuket',
    'krabi',
    'koh-lipe',
    'koh-phi-phi',
    'ko-lanta',
    'khao-sok',
    'similan-islands',
    'ko-surin-nuea',
    'emerald-cave',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'koh-kood': [
    'koh-chang',
    'pattaya',
    'koh-larn',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'koh-chang': [
    'koh-kood',
    'pattaya',
    'koh-larn',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'hua-hin': [
    'kanchanaburi',
    'pattaya',
    'koh-larn',
    'bangkok',
    'bangkok-markets',
    'floating-market',
    'train-night-market',
    'general-thailand',
    'thailand-tax-refund',
  ],
  pattaya: [
    'kanchanaburi',
    'hua-hin',
    'koh-larn',
    'bangkok',
    'bangkok-markets',
    'train-night-market',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'doi-inthanon': [
    'pai',
    'chiang-rai',
    'khlong-mae-kha',
    'chiang-mai',
    'chiang-mai-markets',
    'chiang-mai-attractions',
    'chiang-mai-pai-chiang-rai-road-attractions',
    'thailand-myanmar-border-trip',
    'chiang-rai-to-golden-triangle',
    'chiang-rai-to-chiang-mai',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'wat-saket': [
    'ko-kret',
    'bangkachao',
    'lumphini-park',
    'benchakitti-park',
    'bangkok',
    'kanchanaburi',
    'bangkok-transportation',
    'bangkok-markets',
    'bangkok-malls',
    'khaosan-road',
    'floating-market',
    'train-night-market',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'koh-larn': [
    'hua-hin',
    'pattaya',
    'kanchanaburi',
    'bangkok',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'khlong-mae-kha': [
    'pai',
    'chiang-rai',
    'chiang-mai',
    'doi-inthanon',
    'chiang-mai-markets',
    'chiang-mai-attractions',
    'chiang-mai-pai-chiang-rai-road-attractions',
    'thailand-myanmar-border-trip',
    'chiang-rai-to-golden-triangle',
    'chiang-rai-to-chiang-mai',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'ko-kret': [
    'bangkok',
    'bangkachao',
    'lumphini-park',
    'benchakitti-park',
    'wat-saket',
    'kanchanaburi',
    'bangkok-transportation',
    'bangkok-markets',
    'bangkok-malls',
    'khaosan-road',
    'floating-market',
    'train-night-market',
    'general-thailand',
    'thailand-tax-refund',
  ],
  bangkachao: [
    'bangkok',
    'ko-kret',
    'lumphini-park',
    'benchakitti-park',
    'wat-saket',
    'kanchanaburi',
    'bangkok-transportation',
    'bangkok-markets',
    'bangkok-malls',
    'khaosan-road',
    'floating-market',
    'train-night-market',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'lumphini-park': [
    'bangkok',
    'bangkachao',
    'ko-kret',
    'benchakitti-park',
    'wat-saket',
    'kanchanaburi',
    'bangkok-transportation',
    'bangkok-markets',
    'bangkok-malls',
    'khaosan-road',
    'floating-market',
    'train-night-market',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'benchakitti-park': [
    'bangkok',
    'bangkachao',
    'lumphini-park',
    'ko-kret',
    'wat-saket',
    'kanchanaburi',
    'bangkok-transportation',
    'bangkok-markets',
    'bangkok-malls',
    'khaosan-road',
    'floating-market',
    'train-night-market',
    'general-thailand',
    'thailand-tax-refund',
  ],
  'emerald-cave': [
    'krabi',
    'koh-phi-phi',
    'ko-lanta',
    'koh-lipe',
    'khao-lak',
    'khao-sok',
    'similan-islands',
    'ko-surin-nuea',
    'phuket',
    'general-thailand',
    'thailand-tax-refund',
  ],
};
